import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {InventoryBarcodeData} from "./inventory-barcode.data";

@Injectable()
export class InventoryBarcodeEntityModel extends EntityModel<InventoryBarcodeData> {
    constructor(injector: Injector) {
        super(injector, InventoryBarcodeData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
